import React from 'react';
import {MasterLayout} from 'components/layouts';
import {SearchCategory} from 'components/category-detail';
import {AllCategoriesContainer} from 'components/all-categories';
import title from 'constants/TitlePages.js';
import {CategoryMenu} from 'components/category';

class AllCategories extends React.Component {

  componentDidMount() {
    document.title = title.AllCategories;
  }

  render() {
    return (
      <MasterLayout>
        <section className='center page-all-categories'>
          <div className="list-category-S">
            <h2 className='category-S-title'>Nhóm sản phẩm</h2>
            <div className='category-S-wrap-content'>
              <div className='category-S-left-list'>
                <AllCategoriesContainer/>
                <CategoryMenu isShowAll={true}/>
              </div>
              {/*<div className='category-S-right-filter'>
                <SearchCategory/>
              </div>*/}
            </div>
          </div>
        </section>
      </MasterLayout>
    );
  }
}

export default AllCategories;



// WEBPACK FOOTER //
// ./pages/AllCategories.jsx